import React, {useEffect, useState} from 'react'
import {initLanding} from "../../services/serviceReports";
import RequestLog from "./requestLog/RequestLog";
import Appointments from "./appoitnments/Appointments";
import Bids from "./bids/Bids";
import Counts from "./counts/Counts";
import Productions from "./productions/Productions";
import {Col, Row, Space} from "antd";
import {cyan ,grey} from "@ant-design/colors";


const containerStyle = {
    padding: '12px 24px'
}


const LandingContent = () => {
    const [data, setData] = useState({})
    const [clock, setClock] = useState(new Date())


    useEffect(() => {
        initLanding()
            .then(({data}) => setData(data))
    }, [])

    useEffect(() => {
        const interval = setInterval(() => startClock(), 1000);

        return () => clearInterval(interval);
    })

    const startClock = () => setClock(new Date())

    return (
        <React.Fragment>
            <div style={containerStyle}>
                <Space direction={'vertical'} size={32} style={{width: '100%'}}>
                    <Row justify={'space-between'}>
                        <Col>
                            <Counts data={data}/>
                        </Col>
                        <Col style={{textAlign: 'right'}}>
                            <h5 style={{color: grey[12]}}>{clock.toLocaleDateString()}</h5>
                            <h5 style={{color: cyan[7]}}>{clock.toLocaleTimeString()}</h5>
                        </Col>
                    </Row>
                    <Bids data={data}/>
                    <Appointments data={data}/>
                    <Row gutter={32}>
                        <Col span={12}>
                            <Space direction={'vertical'} size={12} style={{width: '100%'}}>
                                <h5>Üretim</h5>
                                <Productions data={data} />
                            </Space>
                        </Col>
                        <Col span={12}>
                            <Space direction={'vertical'} size={12} style={{width: '100%'}}>
                                <h5>Son İşlemler</h5>
                                <RequestLog data={data}/>
                            </Space>
                        </Col>
                    </Row>
                </Space>
            </div>
        </React.Fragment>
    )
}
export default LandingContent